// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--v2o0q","image":"_93444fe79c--image--Ge6_a"};